import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { AuthService } from './AuthService';
import { CertificadoService } from './certificado.service';
import { PushNotificationsService } from './push-notifications.service';
import { HelpToursService } from '../tours/help-tours.service';

import { k } from 'src/environments/properties';

@Injectable({
  providedIn: 'root'
})
export class AuthSessionService {

  private readonly returnUrl = '/dashboard/default';
  private readonly returnUrlProfile = '/perfil/perfil';

  constructor(
    private authService: AuthService,
    private certificadoService: CertificadoService,
    private helpToursService: HelpToursService,
    private pushNotificationsService: PushNotificationsService,
    private router: Router
  ) {}

  async completeLogin(accessToken: string): Promise<void> {

    if (!accessToken?.trim()) {
      throw new Error('No se recibió un access token válido');
    }

    // 1. Obtener información del usuario
    const dataUser = await this.authService.dataUser(accessToken);

    // 2. Guardar sesión
    this.saveSession(accessToken, dataUser);

    // 3. Guardar cookie
    this.saveAccessTokenCookie(accessToken);

    // 4. Consultar certificados
    const responseCert = await lastValueFrom(
      this.certificadoService.getCertificados(dataUser.id)
    );

    // 5. Configurar tour
    this.helpToursService.setTourEnabled(
      dataUser.accesoGuiado
    );

    // 6. Navegar
    if (responseCert?.body?.length === 0) {
      await this.router.navigate([
        this.returnUrlProfile
      ]);
    } else {
      await this.router.navigate([
        this.returnUrl
      ]);
    }

    // 7. Push notifications
    this.initializePushNotifications();
  }

  private saveSession(
  accessToken: string,
  dataUser: any
): void {

  /*
   * ==========================================
   * STORAGE
   * ==========================================
   */

  localStorage.setItem(
    k.user_id,
    String(dataUser.id)
  );

  localStorage.setItem(
    k.token,
    accessToken
  );

  localStorage.setItem(
    k.user_name,
    `${dataUser.firstName} ${dataUser.lastName}`
  );

  localStorage.setItem(
    k.tipoGrupo,
    dataUser.tipoGrupo
  );

  localStorage.setItem(
    k.correo,
    dataUser.email
  );

  localStorage.setItem(
    k.userInformation,
    JSON.stringify(dataUser)
  );


  /*
   * ==========================================
   * ESTADO REACTIVO DEL AuthService
   * ==========================================
   */

  this.authService.currentUser.next(
    dataUser
  );

  this.authService.token$.next(
    accessToken
  );


  /*
   * ==========================================
   * MFA
   * ==========================================
   *
   * Si llegamos a completeLogin(), ya tenemos
   * un access_token definitivo.
   *
   * El partial_token ya no debe existir.
   */

  localStorage.removeItem(
    k.partial_token
  );
}


  private saveAccessTokenCookie(
    accessToken: string
  ): void {

    document.cookie =
      `access_token=${accessToken}; path=/; secure; samesite=strict;`;
  }

  private initializePushNotifications(): void {

    setTimeout(() => {

      if (Notification.permission !== 'denied') {
        this.pushNotificationsService
          .subscribeToNotifications();
      }

    }, 1000);
  }

}